import { Heading, Text, Box, Badge, Button, Flex } from '@chakra-ui/react';
import * as React from 'react';
export default {
  Heading,
  Text,
  Box,
  Badge,
  Button,
  Flex,
  React
};